import { History } from "history";
import * as React from "react";
import delay from "utils/delay";

export interface IProp {
  history: History;
}

export default class Accept extends React.PureComponent<IProp> {
  constructor(props: IProp) {
    super(props);
  }

  public async componentDidMount() {
    await delay(1000);
    this.props.history.push("/");
  }

  public render() {
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/screens/Authorization/accept.tsx